<template>
  <div>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(save)">
        <SubHeader :title="'Claim ' + (claimIndex + 1)" />
        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'claimStatus' + index + '-' + claimIndex">
              Claim Status
            </label>
          </b-col>
          <b-col md="9">
            <b-form-select :id="'claimStatus' + index + '-' + claimIndex"
                           :options="claimStatuses"
                           v-model="claim.companyRandDQualificationClaimStatusId"
                           value-field="id"
                           text-field="name"
                           :disabled="claim.id == 0">
              <template v-slot:first>
                <b-form-select-option :value="null">-</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'ElicitationDate' + index + '-' + claimIndex">
              Elicitation Complete?
            </label>
          </b-col>
          <b-col md="9">
            <b-form-datepicker :id="'ElicitationDate' + index + '-' + claimIndex"
                               :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
                               locale="en-GB"
                               v-model="claim.elicitationDate"></b-form-datepicker>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'awardExpectedToClient' + index + '-' + claimIndex"> Total R&D award expected to client </label>
          </b-col>
          <b-col md="9">
            <b-input-group>
              <b-input-group-prepend is-text>
                £
              </b-input-group-prepend>
              <b-form-input :id="'awardExpectedToClientDisplay' + index + '-' + claimIndex"
                            type="text"
                            @focus="onFocusText('awardExpectedToClient', index, claimIndex)">
              </b-form-input>
              <b-form-input :id="'awardExpectedToClient' + index + '-' + claimIndex"
                            type="number"
                            step="0.01"
                            v-model="claim.awardExpectedToClient"
                            class="currencyToConvert"
                            @blur="onBlurNumber('awardExpectedToClient', index, claimIndex)"
                            hidden>
              </b-form-input>
            </b-input-group>
          </b-col>
        </b-row>



        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'fullCommissionAmountExpected' + index + '-' + claimIndex"> Full Commission Amount Expected to RandD </label>
          </b-col>
          <b-col md="9">
            <b-input-group>
              <b-input-group-prepend is-text>
                £
              </b-input-group-prepend>
              <b-form-input :id="'fullCommissionAmountExpectedDisplay' + index + '-' + claimIndex"
                            type="text"
                            @focus="onFocusText('fullCommissionAmountExpected', index, claimIndex)">
              </b-form-input>
              <b-form-input :id="'fullCommissionAmountExpected' + index + '-' + claimIndex"
                            type="number"
                            step="0.01"
                            v-model="claim.fullCommissionAmountExpected"
                            class="currencyToConvert"
                            @blur="onBlurNumber('fullCommissionAmountExpected', index, claimIndex)"
                            hidden>
              </b-form-input>

            </b-input-group>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'ExpectedSubmissionDate' + index + '-' + claimIndex"> Expected Submission Date </label>
          </b-col>
          <b-col md="9">
            <b-form-datepicker :id="'ExpectedSubmissionDate' + index + '-' + claimIndex"
                               :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
                               locale="en-GB"
                               v-model="claim.expectedSubmissionDate"></b-form-datepicker>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'DateSubmittedToHMRC' + index + '-' + claimIndex"> Date Submitted To HMRC </label>
          </b-col>
          <b-col md="9">
            <b-form-datepicker :id="'DateSubmittedToHMRC' + index + '-' + claimIndex"
                               :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
                               locale="en-GB"
                               v-model="claim.dateSubmittedToHMRC"></b-form-datepicker>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'HMRCProcessedValue' + index + '-' + claimIndex"> HMRC Processed Value </label>
          </b-col>
          <b-col md="9">
            <b-input-group>
              <b-input-group-prepend is-text>
                £
              </b-input-group-prepend>
              <b-form-input :id="'hmrcProcessedValueDisplay' + index + '-' + claimIndex"
                            type="text"
                            @focus="onFocusText('hmrcProcessedValue', index, claimIndex)">
              </b-form-input>
              <b-form-input :id="'hmrcProcessedValue' + index + '-' + claimIndex"
                            type="number"
                            step="0.01"
                            v-model="claim.hmrcProcessedValue"
                            class="currencyToConvert"
                            @blur="onBlurNumber('hmrcProcessedValue', index, claimIndex)">
              </b-form-input>
            </b-input-group>


          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'DatePaid' + index + '-' + claimIndex"> Date Paid </label>
          </b-col>
          <b-col md="9">
            <b-form-datepicker :id="'DatePaid' + index + '-' + claimIndex"
                               :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
                               locale="en-GB"
                               v-model="claim.datePaid"></b-form-datepicker>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'FeeReceived' + index + '-' + claimIndex"> Fee Received </label>
          </b-col>
          <b-col md="9">
            <b-input-group>
              <b-input-group-prepend is-text>
                £
              </b-input-group-prepend>
              <b-form-input :id="'feeReceivedDisplay' + index + '-' + claimIndex"
                            type="text"
                            @focus="onFocusText('feeReceived', index, claimIndex)">
              </b-form-input>
              <b-form-input :id="'feeReceived' + index + '-' + claimIndex"
                            type="number"
                            step="0.01"
                            v-model="claim.feeReceived"
                            class="currencyToConvert"
                            @blur="onBlurNumber('feeReceived', index, claimIndex)"
                            hidden>
              </b-form-input>

            </b-input-group>


          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'LastChasedDate' + index + '-' + claimIndex"> Last Chased </label>
          </b-col>
          <b-col md="9">
            <b-form-datepicker :id="'LastChasedDate' + index + '-' + claimIndex"
                               :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
                               locale="en-GB"
                               v-model="claim.lastChasedDate"></b-form-datepicker>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'termsOfContract' + index + '-' + claimIndex">
              Claim Notes
            </label>
          </b-col>
          <b-col md="9">
            <b-form-textarea :id="'ClaimNotes' + index + '-' + claimIndex"
                             v-model="claim.claimNotes"
                             rows="3"></b-form-textarea>
          </b-col>
        </b-row>


      </b-form>
    </validation-observer>
  </div>
</template>

<script>

  import SubHeader from "@/components/shared/SubHeader.vue";

  export default {
    components: { SubHeader },
    props: {
      claim: Object,
      index: Number,
      claimIndex: Number,
      claimStatuses: Array
    },
    data() {
      return {
        months: [
          { id: 1, name: "January" },
          { id: 2, name: "February" },
          { id: 3, name: "March" },
          { id: 4, name: "April" },
          { id: 5, name: "May" },
          { id: 6, name: "June" },
          { id: 7, name: "July" },
          { id: 8, name: "August" },
          { id: 9, name: "September" },
          { id: 10, name: "October" },
          { id: 11, name: "November" },
          { id: 12, name: "December" }],
        amount: null,
        temp: null,
        visible: true
      }

    },
    computed: {

    },
    mounted() {
      var elements = document.getElementsByClassName("currencyToConvert");
      for (let element of elements){
        var stringElement = element.id;

        var elementName = stringElement.substring(0, stringElement.length - 3);
        var elementIndex = stringElement.substring(stringElement.length - 3, stringElement.length - 2);
        var ClaimIndex = stringElement.substring(stringElement.length - 1, stringElement.length);
        this.onBlurNumber(elementName, elementIndex, ClaimIndex);
      }
    },

    watch: {
      expectedAmount(val) {
        console.log(val);
        this.claim.expectedAmount = 3500;
      },
    },
    methods: {
      updateFinalInvoiceValue() {
        this.$parent.finalInvoiceValue()
      },
      blurStart() {

      },

      thousandSeprator(amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        else {
          return amount;
        }
      },
      onBlurNumber(elementName, indexNr, claimIndexNr) {
        var displayElement = elementName + 'Display' + indexNr + '-' + claimIndexNr;
        var realElement = elementName + indexNr + '-' + claimIndexNr;
        var value = document.getElementById(realElement).value;
        var formattedValue = this.convertToFormattedCurrency(value);

        document.getElementById(displayElement).value = formattedValue;
        document.getElementById(displayElement).hidden = false;

        document.getElementById(realElement).hidden = true;


      },
      onFocusText(elementName, indexNr, claimIndexNr) {

        var displayElement = elementName + 'Display' + indexNr + '-' + claimIndexNr;
        var realElement = elementName + indexNr + '-' + claimIndexNr;
        var value = document.getElementById(realElement).value;

        document.getElementById(displayElement).hidden = true;
        document.getElementById(realElement).hidden = false;
        document.getElementById(realElement).focus();
        document.getElementById(realElement).value = value;

      },
      convertToFormattedCurrency(value) {

        var valueToUse = String(value);
        //var newCleanValue = newValue.replace(",", "");

        var wholeNumbers = "";
        var decimal = "";
        if (valueToUse.includes(".")) {
          wholeNumbers = valueToUse.substring(0, valueToUse.indexOf("."));
          decimal = valueToUse.substring(valueToUse.indexOf("."));
        }
        else {
          wholeNumbers = valueToUse;
        }
        if (decimal.length == 2) {
          decimal = decimal + "0";
        }
        //var finalNewValue = wholeNumbers.replace(",", "")+decimal;
        var formattedNewValue = wholeNumbers.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") + decimal;
        return formattedNewValue;

      },

      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      maxYear() {
        var date = new Date();
        return date.getFullYear() + 10;
      }
    }
  };


</script>

<style>
  .subsubheader {
    font-weight: 500;
    font-size: 1.2em;
  }
</style>
